// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/ReversibleArrow/ReversibleArrow.less
// module id = 830
// module chunks = 0